import { Box } from '@mui/material';
import { useAppSelector } from '../../redux/hooks';
import { StyledBox } from './BookingSettings';
import LinkedCalendar from '../../components/BookingSettings/LinkedAccounts/LinkedCalendars';
import LinkedVideoPlatform from '../../components/BookingSettings/LinkedAccounts/LinkedVideoPlatform';

const LinkedAccounts = () => {
  const coachConfigurations = useAppSelector((state) => state.booking.coachConfigurations);
  return (
    <Box>
      <StyledBox width="50%" maxHeight={300} gap="3px">
        <LinkedCalendar />
      </StyledBox>
      {coachConfigurations.isProvideOnlineConsultations && (
        <StyledBox width="50%" maxHeight={300} gap="3px">
          <LinkedVideoPlatform />
        </StyledBox>
      )}
    </Box>
  );
};

export default LinkedAccounts;
